import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import Card from '../components/Card';
import Loader from '../components/Loader'; // Importar el Loader
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [properties, setProperties] = useState([]); // Estado para almacenar las propiedades
  const [isLoading, setIsLoading] = useState(true); // Estado para mostrar Loader
  const [isRedirecting, setIsRedirecting] = useState(false); // Estado para evitar parpadeos
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // Base URL desde .env
  const token = localStorage.getItem('token'); // Obtener token del localStorage
  const { t } = useTranslation('home'); // Usar traducciones del namespace "home"
  const navigate = useNavigate(); // Para redirigir al usuario

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        // Hacer la petición GET a la API
        const response = await axios.get(`${API_BASE_URL}properties/user/properties`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const userProperties = response.data.properties || [];
        setProperties(userProperties);
        setIsLoading(false); // Ocultar el Loader cuando los datos están listos

        // Si solo hay una propiedad y el usuario es un guest, redirigir automáticamente
        if (userProperties.length === 1 && userProperties[0].role === 'guest') {
          setIsRedirecting(true); // Evita que se renderice antes de redirigir
          navigate(`/devices/${userProperties[0].propertyId}`);
        }
      } catch (error) {
        console.error('Error al obtener las propiedades:', error);

        // Si el error indica que el token es inválido
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // Elimina el token del almacenamiento local
          localStorage.removeItem('token');
          localStorage.removeItem('user');

          // Redirige al usuario a la página de inicio de sesión
          navigate('/login');
        } else {
          // En caso de otro error, limpia las propiedades
          setProperties([]);
        }
      } finally {
        setTimeout(() => setIsLoading(false), 500); // Evita parpadeos bruscos
      }
    };

    fetchProperties();
  }, [API_BASE_URL, token, navigate]);

  // Si se está redirigiendo, no mostrar contenido
  if (isRedirecting) {
    return null;
  }

  return (
    <StyledHome>
      <div className="home-container">
        {/* Título traducido */}
        <h1>{t('welcome')}</h1>
        
        {/* Mostrar Loader si los datos aún se están cargando */}
        {isLoading ? (
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        ) : properties.length === 1 ? (
          <>
            {/* Mostrar la tarjeta de la única propiedad */}
            <Card
              name={properties[0].name}
              address={properties[0].address}
              role={properties[0].role}
              imageUrl={
                properties[0].images &&
                Array.isArray(properties[0].images) &&
                properties[0].images.length > 0
                  ? properties[0].images[0]
                  : 'https://via.placeholder.com/300x150?text=Sin+Imagen'
              }
              propertyId={properties[0].propertyId}
            />
          </>
        ) : (
          <>
            {/* Traducción para múltiples propiedades */}
            <div className="card-container">
              {properties.map((property) => (
                <Card
                  key={property.propertyId}
                  name={property.name}
                  address={property.address}
                  role={property.role}
                  imageUrl={
                    property.images &&
                    Array.isArray(property.images) &&
                    property.images.length > 0
                      ? property.images[0]
                      : 'https://via.placeholder.com/300x150?text=Sin+Imagen'
                  }
                  propertyId={property.propertyId}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </StyledHome>
  );
};

// Loader centrado mientras se cargan las propiedades
const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`;

const StyledHome = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  .home-container {
    text-align: center;
    padding: 20px;
    background: white;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    border-radius: 10px;

    h1 {
      font-size: 2rem;
      margin-bottom: 20px;
    }

    .card-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;
      margin-top: 20px;
    }
  }
`;

export default Home;